import React from 'react';
import { Button, Row } from 'react-bootstrap';

const Pagination = ({ renderPaginationNumbers,
    previousPage,
    nextPage, canPreviousPage, canNextPage }) => {


    return (
        <div className="col-sm-auto">
            <ul className="pagination pagination-separated mb-0 justify-content-center justify-content-sm-start">
                <li className={!canPreviousPage ? 'page-item disabled' : 'page-item'} onClick={previousPage}>
                    <Button variant="link" className="page-link">Previous</Button>
                </li>
                {renderPaginationNumbers}
                <li className={!canNextPage ? 'page-item disabled' : 'page-item'} onClick={nextPage}>
                    <Button variant="link" className="page-link">Next</Button>
                </li>
            </ul>

        </div>
    )
}

export default Pagination